import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=fbc1105a&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc1105a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc1105a')) {
      api.createRecord('fbc1105a', component.options)
    } else {
      api.reload('fbc1105a', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=fbc1105a&scoped=true&", function () {
      api.rerender('fbc1105a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Auth/ForgotPassword.vue"
export default component.exports